import { render, staticRenderFns } from "./Traffic.vue?vue&type=template&id=74c8e8fc&"
import script from "./Traffic.vue?vue&type=script&lang=js&"
export * from "./Traffic.vue?vue&type=script&lang=js&"
import style0 from "./Traffic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports